module.exports = function (app, mod) {
  return "\n      <div class=\"lessons\">\n        <div class=\"popup-intersection\" id=\"popup-intersection\"></div>\n      </div>\n  ";
};